import { render, staticRenderFns } from "./AgroHome.vue?vue&type=template&id=1039e196&"
import script from "./AgroHome.vue?vue&type=script&lang=js&"
export * from "./AgroHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports